import React from 'react';
import { Modal, Backdrop, Fade, Typography, Button, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import RenderFieldBasedOnType from '../RenderFieldsBasedOnType';
import useAddSpendModalStyles from './AddSpendModal.style';

/**
 * Modal form to create a new spend row from configured data elements.
 */
const AddSpendModal = (props) => {
    const {
        open,
        onClose,
        onSave,
        title,
        formDataElements,
        formData,
        handleOnFieldChange,
        isSaving,
    } = props;
    const classes = useAddSpendModalStyles();

    return (
        <Modal
            open={open}
            onClose={(event, reason) => {
                if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                    return;
                }
                onClose();
            }}
            className={classes.modal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{ timeout: 500 }}
            disableEscapeKeyDown
        >
            <Fade in={open}>
                <div className={classes.paper}>
                    <div className={classes.header}>
                        <div>
                            <Typography className={classes.title}>{title || 'Add New Spend'}</Typography>
                            <Typography className={classes.subtitle}>
                                Enter the spend details below. Scroll to view all available fields.
                            </Typography>
                        </div>
                        <IconButton
                            className={classes.closeButton}
                            onClick={onClose}
                            disabled={isSaving}
                            aria-label="Close add spend modal"
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </div>

                    <div className={`${classes.form} myScrollContainer`}>
                        {formDataElements?.length > 0 &&
                            formDataElements.map((element, index) => (
                                <div key={element.value || element.name || index} className={classes.formItem}>
                                    <Typography className={classes.label}>
                                        {element.label}
                                        {element.required ? <span style={{ color: '#D32F2F' }}> *</span> : null}
                                    </Typography>
                                    <RenderFieldBasedOnType
                                        {...props}
                                        classes={classes}
                                        element={element}
                                        onChange={handleOnFieldChange}
                                        dataObj={formData}
                                        options={element?.data?.options ? element.data.options : {}}
                                        selectedStep={{}}
                                    />
                                    {element.helperText ? (
                                        <Typography className={classes.helper}>{element.helperText}</Typography>
                                    ) : null}
                                </div>
                            ))}
                    </div>

                    <div className={classes.footer}>
                        <Button
                            variant="outlined"
                            size="small"
                            className={classes.cancelButton}
                            onClick={onClose}
                            disabled={isSaving}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            className={classes.saveButton}
                            onClick={onSave}
                            disabled={isSaving}
                        >
                            {isSaving ? 'Saving...' : 'Save'}
                        </Button>
                    </div>
                </div>
            </Fade>
        </Modal>
    );
};

export default AddSpendModal;
